import { format } from "date-fns";
import RoadSpinner from "../../components/loads/RoadSpinner";

const Notas = ({
  data,
  setData,
  filter,
  setFilter,
  onClick,
  loading,
  fetch,
  onChange,
}) => {
  return (
    <div className="min-vh-100 container">
      <div className="px-3">
        <div className="d-flex justify-content-between">
          <h2 className="me-2">NOTAS</h2>
          <label
            className="btn btn-custom-naranja fw-normal GothamBold text-white px-4 d-flex align-items-center"
            style={{ borderRadius: "10px", height: "45px" }}
          >
            NUEVA NOTA
            <button
              className="d-none"
              name="nuevo_evento"
              onClick={(event) => onClick(event)}
            ></button>
          </label>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-3 mb-3">
                <input
                  className="form-control border border-dark py-1"
                  style={{ borderRadius: "10px 0px 0px 10px" }}
                  type="search"
                  name="search"
                  placeholder="Buscar"
                  onChange={(e) => onChange(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      onClick({ target: { name: "search" } });
                  }}
                />
              </div>
              <div className="col-md-3 mb-3">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  onChange={(e) => {
                    if (e.target.value == "todos") {
                      let params = filter;
                      delete params["filter[stated]"];
                      setFilter({ ...params });
                      return fetch(setData, params, "/notas");
                    }
                    setFilter({
                      ...filter,
                      ["filter[stated]"]: e.target.value,
                    });
                    let params = {
                      ...filter,
                      ["filter[stated]"]: e.target.value,
                    };
                    fetch(setData, params, "/notas");
                  }}
                >
                  {["filter[stated]"] in filter ? (
                    <option selected>
                      {
                        [
                          { value: "Todos", label: "Todos" },
                          { value: "ACTIVO", label: "Activo" },
                          { value: "PAUSADO", label: "Pausado" },
                          { value: "ELIMINADO", label: "Eliminado" },
                          { value: "BORRADOR", label: "Borrador" },
                        ].filter((c) => c.value == filter["filter[stated]"])[0]
                          .label
                      }
                    </option>
                  ) : (
                    <option selected>Seleccionar estado</option>
                  )}
                  {[
                    { value: "Todos", label: "Todos" },
                    { value: "ACTIVO", label: "Activo" },
                    { value: "PAUSADO", label: "Pausado" },
                    { value: "ELIMINADO", label: "Eliminado" },
                    { value: "BORRADOR", label: "Borrador" },
                  ].map((status) => {
                    if (["filter[stated]"] in filter) {
                      if (filter["filter[stated]"] == status.value) {
                        return "";
                      }
                    }
                    return <option value={status.value}>{status.label}</option>;
                  })}
                </select>
              </div>
            </div>
          </div>

          <div className="card col-md-12">
            <table class="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th className="d-none d-md-table-cell">
                    <div className="d-flex justify-content-between">#ID</div>
                  </th>
                  <th className="">
                    <div className="d-flex justify-content-between">TITULO</div>
                  </th>
                  <th className="d-none d-md-table-cell">
                    <div className="d-flex justify-content-between">FECHA</div>
                  </th>
                  <th className="d-none d-md-table-cell">
                    <div className="d-flex justify-content-between">AUTOR</div>
                  </th>
                  <th className="d-none d-md-table-cell">
                    <div className="d-flex justify-content-between">
                      CATEGORIAS
                    </div>
                  </th>
                  <th className="d-none d-md-table-cell">
                    <div className="d-flex justify-content-between">ESTADO</div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={10}>
                      <RoadSpinner />
                    </td>
                  </tr>
                ) : (
                  data.data.map((nota) => {
                    return (
                      <tr>
                        <td className="Grifter d-none d-md-table-cell">
                          #{nota.id}
                        </td>
                        <td className="">
                          <div className="d-flex align-items-center">
                            <img
                              src={`https://antesala.com.ar/assets/img/notas/${nota.imagen}`}
                              alt="Evento"
                              className="rounded me-3"
                              width="48"
                              height="48"
                            />
                            <span className="fw-medium">{nota.titulo}</span>
                          </div>
                        </td>
                        <td className="d-none d-md-table-cell">
                          {format(
                            new Date(nota.created_at),
                            "dd/M/yyyy"
                          ).toString()}
                        </td>
                        <td className="Grifter d-none d-md-table-cell">
                          {nota.autor}
                        </td>
                        <td className="d-none d-md-table-cell">
                          {nota.categorias.map((categoria) => {
                            return (
                              <span class="badge bg-secondary text-bg-secondary me-1 mb-1">
                                {categoria.nombre}
                              </span>
                            );
                          })}
                        </td>
                        <td className="d-none d-md-table-cell">
                          <div class="dropdown">
                            <button
                              class="btn text-white border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                              style={{ borderRadius: "10px" }}
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span className="text-dark">{nota.stated}</span>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <label className="btn m-0 p-0">
                                  <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                                  Activar
                                  <button
                                    className="d-none"
                                    name="stated"
                                    onClick={(event) =>
                                      onClick(event, {
                                        id: nota.id,
                                        status: "ACTIVO",
                                      })
                                    }
                                  ></button>
                                </label>
                              </li>
                              <li>
                                <label className="btn m-0 p-0">
                                  <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                  Pausar
                                  <button
                                    className="d-none"
                                    name="stated"
                                    onClick={(event) =>
                                      onClick(event, {
                                        id: nota.id,
                                        status: "INACTIVO",
                                      })
                                    }
                                  ></button>
                                </label>
                              </li>
                              <li>
                                <label className="btn m-0 p-0">
                                  <i class="text-danger mx-1 bi bi-trash"></i>
                                  Eliminar
                                  <button
                                    className="d-none"
                                    name="stated"
                                    onClick={(event) =>
                                      onClick(event, {
                                        id: nota.id,
                                        status: "PAUSADO",
                                      })
                                    }
                                  ></button>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <label className={`btn btn-sm btn-outline-dark`}>
                            <i class="bi bi-pencil-square"></i>
                            <button
                              className="d-none"
                              name="editar"
                              onClick={(e) => onClick(e, nota.id)}
                            ></button>
                          </label>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Notas;
